import { PromptType } from "../enum/prompt_type";
import VoiceCallErrorModel from "../model/voice_call_error_model";

export const toVoiceCallErrorModel = (error) => {
    const promptType = PromptType.error;
    return new VoiceCallErrorModel({ 
        promptType: promptType, 
        message: error.error,
    });
};